import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
import { Navbar, Button, Tooltip, OverlayTrigger} from 'react-bootstrap';

import logo from '../../assets/images/nave-logo-white.svg';

import dashboradIcon from '../../assets/images/dashboard-menu.svg';
import accountsIcon from '../../assets/images/accounts.svg';
import partnersIcon from '../../assets/images/parthners.svg';
import maintenanceIcon from '../../assets/images/maintenance-icon.svg';
import studentsIcon from '../../assets/images/students.svg';
import notificationsIcon from '../../assets/images/notifications.svg';
import AIIcon from '../../assets/images/ai-icon.svg';

// import reportsIcon from '../../assets/images/reports.svg';

import './Navigation.scss';

class Navigation extends Component {
  state = {
    navigationMenuOpened: true,
    showLinks: true,
  };

  closeMenu = () => {
    document.body.classList.remove('menu-shown');
    this.setState({ navigationMenuOpened: false });
    if (this.props.onMenuToggle) this.props.onMenuToggle(false);
  };

  toggleMenu = () => {
    const { navigationMenuOpened } = this.state;
    if (navigationMenuOpened) {
      document.body.classList.remove('menu-shown');
    } else {
      document.body.classList.add('menu-shown');
    }
    this.setState({ navigationMenuOpened: !navigationMenuOpened });
    if (this.props.onMenuToggle) this.props.onMenuToggle(!navigationMenuOpened);
  };

  toggleNavigationMenuOpened = (value) => {
    this.setState({ navigationMenuOpened: value });
    if (this.props.onMenuToggle) this.props.onMenuToggle(value);
  };

  render() {
    const { className } = this.props;
    const { navigationMenuOpened, showLinks } = this.state;

    return (
      <div className={`navigation ${className} ${!navigationMenuOpened ? 'nav-main-close' : 'nav-main-open'} ${!showLinks && 'no-show-link'}`} >
        <div className="navigation-inner">
          
          <div className='header_logo'>
            <Link className="logo" to="/">
              <img src={logo} alt="" />
            </Link>
          
            <Button className='btn-hamburger' onClick={this.toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </Button>
          </div>
          <Navbar className='navbar-nav'>
            <NavLink className='nav-link' exact to="/">
              <span className='images'><img src={dashboradIcon} alt="#" /></span>
              <span className='text'>Dashboard</span>
              <OverlayTrigger placement="right" 
                overlay={<Tooltip id="dashboard-view" className='tooltip_dark max-width-200 text-align-left'>Dashboards</Tooltip>}>
                <span className="tooltip"></span>
              </OverlayTrigger>
            </NavLink>
          
            <NavLink className='nav-link' to="/accounts">
              <span className='images'><img src={accountsIcon} alt="#" /></span>
              <span className='text'>Accounts</span>
              <OverlayTrigger placement="right" 
                overlay={<Tooltip id="accounts-view" className='tooltip_dark max-width-200 text-align-left'>Accounts</Tooltip>}>
                <span className="tooltip"></span>
              </OverlayTrigger>
            </NavLink>
          
            <NavLink className='nav-link' to="/students">
              <span className='images'><img src={studentsIcon} alt="#" /></span>
              <span className='text'>Students</span>
              <OverlayTrigger placement="right" 
                overlay={<Tooltip id="students-view" className='tooltip_dark max-width-200 text-align-left'>Students</Tooltip>}>
                <span className="tooltip"></span>
              </OverlayTrigger>
            </NavLink>
              
            {this.props.user.partner && this.props.user.partner.role !== 'partner' && (
              <NavLink className='nav-link' to="/partners">
                <span className='images'><img src={partnersIcon} alt="#" /></span>
                <span className='text'>Partners</span>
                <OverlayTrigger placement="right" 
                  overlay={<Tooltip id="partners-view" className='tooltip_dark max-width-200 text-align-left'>Partners</Tooltip>}>
                  <span className="tooltip"></span>
                </OverlayTrigger>
              </NavLink>
            )}

            {this.props.user.partner && this.props.user.partner.role === 'owner' && this.props.user.role === 'admin' && (
              <NavLink className='nav-link' to="/status">
                <span className='images'><img src={maintenanceIcon} alt="#" /></span>
                <span className='text'>Maintenance</span>
                <OverlayTrigger placement="right" 
                  overlay={<Tooltip id="maintenance-view" className='tooltip_dark max-width-200 text-align-left'>Maintenance</Tooltip>}>
                  <span className="tooltip"></span>
                </OverlayTrigger>
              </NavLink>
            )}

            {this.props.user.partner && this.props.user.partner.role === 'owner' && this.props.user.role === 'admin' && (
              <NavLink className='nav-link' to="/notifications">
                <span className='images'><img src={notificationsIcon} alt="#" /></span>
                <span className='text'>Notifications</span>
                <OverlayTrigger placement="right" 
                  overlay={<Tooltip id="notifications-view" className='tooltip_dark max-width-200 text-align-left'>Notifications</Tooltip>}>
                  <span className="tooltip"></span>
                </OverlayTrigger>
              </NavLink>
            )}

            {this.props.user.partner && this.props.user.partner.role === 'owner' && this.props.user.role === 'admin' && (
                <NavLink className='nav-link' to="/aitools">
                  <span className='images'><img className='settingsIcon' src={AIIcon} alt="#" /></span>
                  <span className='text'>AI Tools</span>
                </NavLink>
            )}

            {/* this.props.user.partner && this.props.user.partner.role !== 'partner' && <Nav.Item><NavLink to='/reports'><img className='reportsIcon' src={reportsIcon} alt="#"/><span>Reports</span></NavLink></Nav.Item> }*/}

          </Navbar>
        </div>
        <div className="btn-open-menu" >
          <button onClick={() => this.toggleNavigationMenuOpened(!navigationMenuOpened)}></button>
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  className: PropTypes.string,
  onMenuToggle: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

export default connect(mapStateToProps)(Navigation);
